<template>
	<div class="hN-body" :class="{'hN-body-nodrag': isMenuOpen}">
		<!-- left-Nav  新版添加新功能首页时不显示 进入功能页后显示-->
		<div class="head-Nav-Left" :class="{'head-nav-none': headNavFlag}">
			<router-link to="/" tag="div">
				<img class="head-Nav-Logo" src="./img/logo/ico_xunjieyasuo_1@2x.png" alt="" />
				<p class="head-Nav-Title">{{ $t("fastcompression") }}</p>
			</router-link>
		</div>
		<!-- right-Nav -->
		<div class="head-Nav-Right">
			<!-- 登录后的头像显示 -->
			<div
				class="head-Nav-Right-Tx"
				:class="{headNavIsLogin: !isLogin}"
				@mouseenter="onhoverOpenDiv('head')"
				@mouseleave="nothoverCloseDiv('head')"
				v-if="!$app.language"
			>
				<!-- 头像 -->
				<div class="head-Nav-Right-Tx-img">
					<img
						:src="
							userData.head_portrait == ''
								? require('./img/head-Nav-Tx/icon_grxxtx30.svg')
								: userData.head_portrait
						"
						alt=""
						@error="imgNotFond($event)"
					/>
				</div>
				<!-- 名称 -->
				<p class="head-Nav-Right-Tx-name">{{ NickName }}</p>
				<!-- hover下滑出现框 -->
				<transition name="it-fade">
					<div
						v-show="isHover.head"
						class="head-Nav-Right-Tx-downdiv"
						:class="'head-Nav-Right-Tx-down' + $app.VIPlevel"
						@mouseenter="divNotClose('head')"
					>
						<!-- 头像id电话 -->
						<div class="head-Nav-Right-Tx-downdiv-Tx">
							<img
								:src="
									userData.head_portrait == ''
										? require('./img/head-Nav-Denglu-3/icon_grxxtx40.svg')
										: userData.head_portrait
								"
								alt=""
								@error="imgNotFond($event)"
							/>
							<div>
								<p>{{ NickName }}</p>
								<p>ID:{{ userData.uid }}</p>
							</div>
						</div>
						<!-- 我的会员 -->
						<p class="head-Nav-Right-Tx-downdiv-VIP-title">{{ $t("mymember") }}</p>
						<!-- 未有vip没有下面内容 -->
						<div
							class="head-Nav-Right-Tx-downdiv-VIP-main"
							v-if="$app.VIPlevel === 1 || $app.VIPlevel === 2 || $app.VIPlevel === 3"
						>
							<p>
								{{ $t("membershiplevel")
								}}<span
									>{{ retime }}<img src="./img/head-Nav-Denglu-3/icon vip nhy.svg" alt=""
								/></span>
							</p>
							<p>
								{{ $t("expirationdate") }}<span>{{ overtime }}</span>
							</p>
						</div>
						<!-- 是否可以购买vip -->
						<div
							v-if="$app.VIPlevel === 0 || $app.VIPlevel === 1 || $app.VIPlevel === 3"
							class="head-Nav-Right-Tx-downdiv-buyvip"
							@click="
								[
									openShopBody(),
									gevt('个人中心', '点击事件', ToPayVIP, 'None', 'None', 'None'),
									gevt('收银台展示量', '收银台事件', '个人中心', 'None', $app.VIPState, 'None'),
								]
							"
						>
							<span>{{ ToPayVIP }}</span>
						</div>
						<!-- 开通vip的特权 -->
						<div
							@click="
								$app.VIPlevel === 0 || $app.VIPlevel === 1 || $app.VIPlevel === 3
									? [
											openShopBody(),
											gevt('个人中心', '点击事件', 'VIP权益', 'None', 'None', 'None'),
											gevt('收银台展示量', '收银台事件', '个人中心', 'None', $app.VIPState, 'None'),
									  ]
									: ''
							"
						>
							<div class="head-Nav-Right-Tx-downdiv-viptq">
								<p class="head-Nav-Right-VIP-shop-title">{{ VIPsuper }}</p>
								<div class="head-Nav-Right-VIP-shop-body">
									<div>
										<img src="../mycomponents/img/vip_shop_hover/img_parameter@2x.png" alt="" />
										<p>{{ $t("customcompressionparameters") }}</p>
									</div>
									<div>
										<img src="./img/vip_shop_hover/img_form@2x.png" alt="" />
										<p>{{ $t("supportmassiveformat") }}</p>
									</div>
									<div>
										<img src="./img/vip_shop_hover/img_document@2x.png" alt="" />
										<p>{{ $t("unlimitedfilesize") }}</p>
									</div>
								</div>
							</div>
						</div>
						<!-- 退出登录 -->
						<div class="head-Nav-Right-Tx-downdiv-outloginbox">
							<hr class="head-Nav-Right-Tx-downdiv-hr" />
							<div class="head-Nav-Right-Tx-downdiv-outlogin" @click="outLogin">
								{{ $t("logout") }}
							</div>
						</div>
					</div>
				</transition>
			</div>
			<!-- 登陆注册   按钮合并-->
			<button
				class="head-Nav-Right-Btn"
				:class="{headNavIsLogin: isLogin}"
				@click="
					openLoginBody();
					clickHandler($event);
				"
				v-if="!$app.language"
			>
				{{ $t("loginregistration") }}
			</button>
			<!-- vip购买  -->
			<button
				class="head-Nav-Right-VIP"
				@mouseenter="onhoverOpenDiv('buy')"
				@mouseleave="nothoverCloseDiv('buy')"
				@click.stop="
					openShopBody_afterLogin('购买VIP');
					clickHandler($event);
				"
				v-if="($app.VIPlevel === 0 || $app.VIPlevel === 1 || $app.VIPlevel === 3) && !$app.language"
			>
				<div class="head-Nav-Right-VIP-box">
					<img
						src="./img/head-Nav-Contral/ico_vip_24-24.svg"
						alt=""
						class="head-Nav-Right-VIP-logo"
					/><span class="head-Nav-Right-VIP-title">{{ $t("buyvip") }}</span>
				</div>
				<!-- vip移动光效  暂时不需要-->
				<!-- <div class="head-Nav-Right-VIP-Light"></div> -->
				<!-- 用于扩充hover范围的div -->
				<!-- <div class="head-Nav-Right-VIP-hoverdiv"></div> -->
				<!-- hover 下滑vip购买 -->
				<transition name="it-fade">
					<div
						v-show="isHover.buy"
						class="head-Nav-Right-VIP-shop"
						@click.stop="
							openShopBody_afterLogin('VIP权益');
							clickHandler($event);
						"
						@mouseenter="divNotClose('buy')"
					>
						<p class="head-Nav-Right-VIP-shop-title">{{ $t("text004") }}</p>
						<div class="head-Nav-Right-VIP-shop-body">
							<div>
								<img src="../mycomponents/img/vip_shop_hover/img_parameter@2x.png" alt="" />
								<p>{{ $t("customcompressionparameters") }}</p>
							</div>
							<div>
								<img src="./img/vip_shop_hover/img_form@2x.png" alt="" />
								<p>{{ $t("supportmassiveformat") }}</p>
							</div>
							<div>
								<img src="./img/vip_shop_hover/img_document@2x.png" alt="" />
								<p>{{ $t("unlimitedfilesize") }}</p>
							</div>
						</div>
						<button>
							<span>{{ $t("buyvipnow") }}</span>
						</button>
					</div>
				</transition>
			</button>
			<!-- 窗口控制 -->
			<!-- <span>|</span> -->
			<!-- 打开菜单 -->
			<div class="head-Nav-Contral-btn contral-caidan" @click.stop="openMenu()">
				<!-- 点击打开的菜单 -->
				<div class="contral-caidan-box"></div>
				<div class="up-contral-caidan-menu">
					<div
						class="contral-caidan-menu"
						:class="{headNavMenu: isMenuOpen, 'contral-caidan-menu_en': $app.language}"
					>
						<a
							href="https://ruanjian.qiyukf.com/client?k=9f6be7423510fa866bf322613deaf43d&wp=1&qtype=4485250&1049844"
							target="_blank"
						>
							<div>
								<img src="./img/head-Nav-other/icon cd kf.svg" alt="" /><span>{{
									$t("contactcustomerservice")
								}}</span>
							</div>
						</a>
						<a href="https://www.xunjiepdf.com/help" target="_blank">
							<div>
								<img src="./img/head-Nav-other/icon cd help.svg" alt="" /><span>{{
									$t("help")
								}}</span>
							</div>
						</a>
						<a href="https://support.qq.com/product/329754" target="_blank">
							<div>
								<img src="./img/head-Nav-other/icon cd wtfk.svg" alt="" /><span>{{
									$t("problemfeedback")
								}}</span>
							</div>
						</a>
					</div>
				</div>
			</div>
			<!-- 缩小界面 -->
			<div class="head-Nav-Contral-btn contral-suoxiao" @click="toMinWindow"></div>
			<!-- 最大化以及放小 -->
			<!-- <div class="head-Nav-Contral-btn contral-zuidahua" @click="max.Click()"></div> -->
			<div
				class="head-Nav-Contral-btn contral-zuidahua"
				v-if="!$app.isFullScreen"
				@click="toMaximize(true)"
			></div>
			<div
				class="head-Nav-Contral-btn contral-zuidahua_return"
				v-else-if="$app.isFullScreen"
				@click="toMaximize(false)"
			></div>
			<!-- <div class="head-Nav-Contral-btn contral-zuidahua"></div> -->
			<!-- 关闭界面 -->
			<div class="head-Nav-Contral-btn contral-guanbi" @click="closeExeBody"></div>
		</div>
	</div>
</template>

<script>
import Shop from "./../pages/dialogs/Shop.vue";
// let ipcRenderer = require("electron").ipcRenderer;
// 定义全局点击函数
import Vue from "vue";
import LoginVue from "../pages/dialogs/Login.vue";
import {format} from "../common/utils";
import gevt from "../plugins/gevt";
import leaveExe from "./../pages/dialogs/Leave.vue";
// import {store} from "../plugins";

export default {
	name: "headNav",
	data() {
		return {
			isHover: {
				head: false,
				buy: false,
			},
			isClose: "",
			timeClose: [],
			isMenuOpen: false,
			defaultImg: require("./img/head-Nav-Tx/icon_grxxtx30.svg"),
			// isFullScreen: false,
		};
	},
	components: {},
	computed: {
		userData: function () {
			// console.log(this.$);
			return this.$local.userLoginData || {};
		},
		isLogin() {
			return !!this.$app.isLogin;
		},
		overtime() {
			if (this.$app.VIPlevel == 2) return this.$t("lifelong");
			return format("YYYY-MM-DD", Date.now() + this.$app.vipRest);
		},
		retime() {
			if (this.$app.VIPlevel == 2) return this.$t("lifetimevip");
			if (this.$app.VIPlevel == 3) return this.$t("annualvip");
			if (this.$app.VIPlevel == 1) return this.$t("monthlyvip");
			return "";
		},
		VIPsuper() {
			if (this.$app.VIPlevel != 2) return this.$t("text004");
			return this.$t("membershipprivileges");
		},
		ToPayVIP() {
			if (this.$app.VIPlevel == 2) return "";
			if (this.$app.VIPlevel == 1 || this.$app.VIPlevel === 3) return this.$t("renewnow");
			return this.$t("openvipnow");
		},
		NickName() {
			if (this.$local.userLoginData) {
				if (!this.$local.userLoginData.nickname) {
					return this.$local.userLoginData.username;
				} else {
					return this.$local.userLoginData.nickname;
				}
			} else return "";
		},
		isHoverNew() {
			return this.isHover.head;
		},
	},
	methods: {
		clickHandler(evt) {
			let target = evt.target;
			// console.log("11111111111111", target.nodeName);
			if (target.nodeName == "SPAN" || target.nodeName == "IMG") {
				target = evt.target.parentNode.parentNode;
			} else if (target.nodeName == "DIV") {
				target = evt.target.parentNode;
			}
			// console.log("222222222", target);
			target.blur();
		},
		imgNotFond(e) {
			let img = e.srcElement;
			img.src = this.defaultImg;
			img.onerror = null; //防止闪图
			console.log("当图片未找到时", e);
		},
		//需要在鼠标移入时打开其他的div(使用定时器控制延时消失)
		onhoverOpenDiv(i) {
			// console.log(this.isHover[i]);
			clearTimeout(this.timeClose[i]);
			this.isHover[i] = true;
		},
		nothoverCloseDiv(i) {
			// console.log("2:当前ishover", this.isHover,str);
			clearTimeout(this.timeClose[i]);
			if (this.isHover[i]) {
				this.timeClose[i] = setTimeout(() => {
					this.isHover[i] = false;
				}, 30);
			}
		},
		divNotClose(i) {
			clearTimeout(this.timeClose[i]);
		},
		// 窗口控制
		// 打开菜单
		openMenu() {
			if (!this.isMenuOpen) {
				this.isMenuOpen = true;
			} else {
				this.isMenuOpen = !this.isMenuOpen;
				if (this.isMenuOpen) {
					this.isMenuOpen = false;
				}
			}
			console.log(this.isMenuOpen);
		},
		gevt(a, b, c, d, e, f) {
			if (a == "收银台展示量") {
				this.$app.theWayToShop = c;
			}
			gevt(a, b, c, d, e, f);
		},
		// 关闭软件
		async closeExeBody() {
			if (this.$app.language) {
				return window.close();
			} else await this.$dlg.show(leaveExe);
			// });
		},
		// 缩小软件最小化
		toMinWindow() {
			hdapi.minimize();
			if (this.$app.isFullScreen) this.$app.isFullScreen = false;
		},
		// 缩小软件最大化
		toMaximize(s) {
			// console.log("s", s);
			hdapi.maximize(!s);
			this.$app.isFullScreen = s;
		},
		// 退出登录
		outLogin() {
			this.$local.userLoginData = null;
			this.$local.detainData = null;
			console.log("登出成功");
		},
		// 打开登录模态框
		async openLoginBody() {
			let loginRetron = await this.$dlg.show(LoginVue);
			console.log("loginRetron", loginRetron);
			return loginRetron;
		},
		// 打开收银台模态框
		openShopBody() {
			this.$dlg.show(Shop);
		},
		// 当点击vip购买并登录后弹出vip购买
		async openShopBody_afterLogin(str) {
			// console.log("===========");
			gevt("VIP角标", "点击事件", str, "None", "None", "None");
			if (this.isLogin) {
				this.openShopBody();
				gevt("收银台展示量", "收银台事件", "VIPicon", "None", this.$app.VIPState, "None");
			} else {
				let iskeep_going = await this.openLoginBody();
				// console.log("iskeep_going", iskeep_going);
				if (iskeep_going && !this.$app.VIPlevel) {
					this.openShopBody();
					gevt("收银台展示量", "收银台事件", "VIPicon", "None", this.$app.VIPState, "None");
				}
			}
		},
		// 全局监听事件
		// 关闭菜单弹框
		closeTableMenu($event) {
			let e = $event;
			let _this = this;
			//获取点击区域是否包含菜单，如果包含，点击的是外部，不包含是菜单内部
			// console.log("点击事件", e);
			if (e.target == document.getElementsByClassName("up-contral-caidan-menu")[0]) return;
			_this.isMenuOpen = false;
		},
	},
	created() {
		// console.log("headNavCreated");
		// console.log("props" + this.$props);
		// store.clearAll;
	},
	mounted() {
		document.addEventListener("click", this.closeTableMenu);
	},
	props: ["headNavFlag"],
	watch: {
		headNavFlag() {
			if (this.headNavFlag) {
				console.log("当前的headNavFlag", this.headNavFlag);
			}
		},
		isHoverNew(val) {
			// console.log("获取新数据", val);
			if (val) {
				// console.log(this.$app.vipRest);
				this.$app.getUserInfo();
				// this.$app.getMemorder();
			}
		},
	},
	beforeDestroy() {
		document.removeEventListener("click", this.closeTableMenu);
	},
};
</script>

<style lang="less" scoped>
.hN-body {
	height: 50rem;
	background-color: #f7f8f9;
	/* line-height: 50rem; */
	-webkit-app-region: drag;
	/* padding: 15rem 25rem 15rem 25rem; */
	box-sizing: border-box;
}
.hN-body-nodrag {
	-webkit-app-region: no-drag !important;
}
.hN-body::after {
	content: "";
	clear: both;
}
/* Nav-left */
.head-Nav-Left {
	/* display: inline-block; */
	display: flex;
	height: 50rem;
	float: left;
	/* vertical-align: middle; */
	-webkit-app-region: no-drag;
	padding-left: 24rem;
}
.head-Nav-Left div::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}
.head-Nav-Logo {
	width: 34rem;
	height: 34rem;
	display: inline-block;
	vertical-align: middle;
	margin-right: 6rem;
	margin-left: 4rem;
	cursor: pointer;
}
.head-Nav-Title {
	display: inline-block;
	vertical-align: middle;
	// width: 81rem;
	height: 29rem;
	font-size: 20rem;
	font-family: Source Han Sans CN;
	cursor: pointer;
	font-weight: bold;
	/* line-height: 18rem; */
	color: #1b212e;
	/* letter-spacing: 10rem; */
	/* vertical-align: middle; */
	/* opacity: 1; */
}

/* Nav-right */
.head-Nav-Right {
	/* display: inline-block; */
	float: right;
	height: 50rem;
	padding-right: 20rem;
	/* margin-left: 56%; */
}
.head-Nav-Right::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}

/* 头像 */
.head-Nav-Right-Tx {
	display: inline-block;
	vertical-align: middle;
	-webkit-app-region: no-drag;
	cursor: pointer;
	height: 30rem;
	position: relative;
	/* background-color: blue; */
}
.head-Nav-Right-Tx-img {
	display: inline-block;
	height: 30rem;
	width: 30rem;
	/* background-image: url("./img/head-Nav-Tx/icongrxxtx.svg"); */
	/* background-size: cover; */
	vertical-align: middle;
	border-radius: 20rem;
	overflow: hidden;
}
.head-Nav-Right-Tx-img img {
	width: 100%;
	height: 100%;
}
.head-Nav-Right-Tx-name {
	/* width: 43rem; */
	display: inline-block;
	vertical-align: middle;
	height: 16rem;
	font-size: 14rem;
	font-family: Arial;
	font-weight: 400;
	/* line-height: 16rem; */
	color: rgba(27, 33, 46, 1);
	/* opacity: 1; */
	margin-right: 15rem;
	margin-left: 5rem;
}
.head-Nav-Right-Tx-downdiv {
	position: absolute;
	/* background-color: bisque; */
	width: 310.36rem;
	/* 用户信息弹窗高度 */
	height: 425.94rem;
	background-image: url("./img/login_hover/bg_vip_05@2x.png");
	background-size: cover;
	left: 50%;
	transform: translateX(-50%);
	padding: 31rem 24rem 0 24rem;
	box-sizing: border-box;
	transition: opacity 0.5s;
	z-index: 99;
	cursor: default;
}
.head-Nav-Right-Tx-down0 {
	height: 367.35rem;
	background-image: url("./img/login_hover/bg_vip_02@2x.png");
}
.head-Nav-Right-Tx-down2 {
	height: 377.36rem;
	background-image: url("./img/login_hover/bg_vip_03@2x.png");
}
/* 头像id电话 */
.head-Nav-Right-Tx-downdiv-Tx {
	margin-bottom: 17rem;
}
.head-Nav-Right-Tx-downdiv-Tx::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}
.head-Nav-Right-Tx-downdiv-Tx img {
	height: 40rem;
	width: 40rem;
	display: inline-block;
	vertical-align: middle;
	margin-right: 11rem;
	border-radius: 20rem;
}
.head-Nav-Right-Tx-downdiv-Tx div {
	display: inline-block;
	vertical-align: middle;
}
.head-Nav-Right-Tx-downdiv-Tx div p:nth-of-type(1) {
	/* width: 98rem; */
	/* height: 17rem; */
	font-size: 16rem;
	font-family: Arial;
	font-weight: bold;
	/* line-height: 18rem; */
	color: #364159;
	opacity: 1;
	margin-bottom: 6rem;
}
.head-Nav-Right-Tx-downdiv-Tx div p:nth-of-type(2) {
	/* width: 53rem; */
	/* height: 14rem; */
	font-size: 12rem;
	font-family: Arial;
	font-weight: 400;
	/* line-height: 14rem; */
	color: #5c7099;
	opacity: 1;
}
/* 我的会员 */
.head-Nav-Right-Tx-downdiv-VIP-title {
	/* width: 56rem; */
	/* height: 20rem; */
	font-size: 14rem;
	font-family: MicrosoftYaHei-Bold;
	/* line-height: 20rem; */
	color: #364159;
	/* letter-spacing: 10rem; */
	opacity: 1;
	margin-bottom: 14rem;
}
.head-Nav-Right-Tx-downdiv-VIP-main img {
	width: 17.2rem;
	height: 13rem;
	margin-left: 4rem;
}
.head-Nav-Right-Tx-downdiv-VIP-main p {
	/* width: 52rem; */
	/* height: 17rem; */
	font-size: 12rem;
	font-family: MicrosoftYaHei;
	/* line-height: 20rem; */
	color: #364159;
	/* letter-spacing: 10rem; */
	opacity: 1;
}
.head-Nav-Right-Tx-downdiv-VIP-main p:nth-of-type(1) {
	margin-bottom: 6rem;
	span {
		img {
			transform: translateY(2rem);
		}
	}
}
.head-Nav-Right-Tx-downdiv-VIP-main {
	margin-bottom: 17rem;
	overflow: hidden;
}
.head-Nav-Right-Tx-downdiv-VIP-main span {
	/* width: 32rem; */
	/* height: 17rem; */
	font-size: 12rem;
	font-family: MicrosoftYaHei;
	/* line-height: 20rem; */
	color: #64360d;
	/* letter-spacing: 10rem; */
	opacity: 1;
	margin-left: 7rem;
}

/* 购买vip */
.head-Nav-Right-Tx-downdiv-buyvip {
	width: 264rem;
	height: 35rem;
	background: linear-gradient(44deg, #f6da65 0%, #ffc43e 100%);
	opacity: 1;
	text-align: center;
	border-radius: 15rem;
	margin-bottom: 11rem;
	margin-top: 3rem;
	cursor: pointer;
}
.head-Nav-Right-Tx-downdiv-buyvip:hover {
	background: #f7d688d7;
}
.head-Nav-Right-Tx-downdiv-buyvip::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}
.head-Nav-Right-Tx-downdiv-buyvip span {
	/* width: 90rem;
	height: 22rem; */
	vertical-align: middle;
	font-size: 16rem;
	font-family: Microsoft YaHei;
	font-weight: 400;
	/* line-height: 19rem; */
	color: #3e2e09;
	opacity: 1;
}

/* 开通vip的特权 */
.head-Nav-Right-Tx-downdiv-viptq {
	margin-bottom: 16rem;
	padding-top: 12rem;
	cursor: pointer;
	.head-Nav-Right-VIP-shop-title {
		width: 100%;
		box-sizing: border-box;
		// padding-left: 25rem;
		text-align: left;
		// margin-top: 35rem;
		margin-bottom: 16rem;
		font-size: 14rem;
		font-family: Microsoft YaHei UI;
		font-weight: 400;
		color: #364159;
	}
	.head-Nav-Right-VIP-shop-body {
		margin-bottom: 25rem;
		div {
			display: inline-block;
			&:nth-of-type(1) {
				margin-right: 14rem;
			}
			&:nth-of-type(2) {
				margin-right: 17rem;
			}
			p {
				font-size: 12rem;
				font-family: Microsoft YaHei UI;
				font-weight: 400;
				color: #64360d;
			}
			img {
				display: block;
				width: 52rem;
				height: 52rem;
				margin-bottom: 8rem;
				margin-left: auto;
				margin-right: auto;
			}
		}
	}
}

/* 退出登录 */
.head-Nav-Right-Tx-downdiv-hr {
	width: 290rem;
	height: 0rem;
	border: 1rem solid #efefef;
	border-bottom: none;
	/* border-bottom: none; */
	opacity: 1;
	transform: translateX(-15rem);
	margin-bottom: 11rem;
}
.head-Nav-Right-Tx-downdiv-outlogin {
	/* width: 48rem; */
	/* height: 17rem; */
	font-size: 12rem;
	font-family: MicrosoftYaHei;
	/* line-height: 20rem; */
	color: #999999;
	/* letter-spacing: 10rem; */
	opacity: 1;
	text-align: center;
	cursor: pointer;
}
.head-Nav-Right-Tx-downdiv-outlogin:hover {
	color: #bebebeec;
}
/* 退出登录hover效果 */
.head-Nav-Right-Tx-downdiv-outloginbox {
	width: 100%;
}
/* 登录注册 */
button:focus {
	outline: 0;
}
.head-Nav-Right-Btn {
	/* width: 55rem; */
	/* height: 30rem; */
	vertical-align: middle;
	-webkit-app-region: no-drag;
	cursor: pointer;
}
/* 登录 +注册*/
.head-Nav-Right-Btn:nth-of-type(1) {
	width: 114rem;
	height: 27rem;
	background-color: rgba(247, 247, 247, 1);
	font-size: 14rem;
	border-radius: 12rem;
	border: rgba(226, 226, 226, 1) 1rem solid;
	font-family: Microsoft YaHei;
	font-weight: 400;
	color: rgba(92, 112, 153, 1);
	opacity: 1;
}
.head-Nav-Right-Btn:nth-of-type(1):hover {
	background-color: #ffffff;
}
.head-Nav-Right-Btn:nth-of-type(1):active {
	background-color: #fafafa;
}
/* 注册 */
/* .head-Nav-Right-Btn:nth-of-type(2) {
	background-color: white;
	color: #474646;
	border-radius: 0rem 20rem 20rem 0rem;
	border: #2f77f1 1rem solid;
}
.head-Nav-Right-Btn:nth-of-type(2):hover {
	color: #518bf0;
	border: #518bf0 1rem solid;
} */
/* vIP */
.head-Nav-Right-VIP {
	/* display: inline-block; */
	padding: 0;
	margin-left: 15rem;
	margin-right: 8rem;
	position: relative;
	/* padding: 5rem 20rem 5rem 20rem; */
	/* box-sizing: border-box; */
	height: 27rem;
	width: 114rem;
	/* border: 1rem solid #e7bd78; */
	border: none;
	background: linear-gradient(44deg, #f6da65 0%, #ffc43e 100%);
	/* color: rgba(62, 46, 9, 1); */
	/* font-size: 14rem; */
	border-radius: 12rem;
	vertical-align: middle;
	-webkit-app-region: no-drag;
	cursor: pointer;
	/* overflow: hidden; */
}
.head-Nav-Right-VIP::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
	clear: both;
}
/* 修复点击hover弹框触发button背景色改变 */
.head-Nav-Right-VIP-box {
	margin: 0;
	padding: 0;
	height: 27rem;
	width: 114rem;
	border-radius: 12rem;
	padding: 1rem 0 0 0;
	display: flex;
	align-items: center;
	justify-content: center;
	/* box-sizing: border-box; */
	/* border: 1rem solid #e7bd78; */
}
.head-Nav-Right-VIP-box:active {
	background: linear-gradient(44deg, #f6cf65 0%, #ffbc3e 100%);
}
.head-Nav-Right-VIP-logo {
	width: 24rem;
	height: 24rem;
}
.head-Nav-Right-VIP-title {
	margin-left: 7rem;
	font-size: 14rem;
	font-family: Microsoft YaHei;
	font-weight: 400;
	/* line-height: 17rem; */
	color: #3e2e09;
	opacity: 1;
}
/*	#head-Nav-Right-VIP-hoverdiv {
	position: absolute;
	background-color: brown;
	display: none;
 	height: 20rem;
	width: 100rem;
	transform: translateX(-50%);
	left: 50%;
} */
/* #head-Nav-Right-VIP-hoverdiv div{
	height: 100%;
	width: 100%;
} */
.head-Nav-Right-VIP-shop {
	z-index: 99;
	margin-top: 5rem;
	transition: opacity 0.5s;
	position: absolute;
	background-image: url("./img/vip_shop_hover/vip_bg_01@2x.png");
	background-size: cover;
	width: 310rem;
	height: 225.17rem;
	left: 50%;
	box-sizing: border-box;
	transform: translateX(-50%);
	cursor: default;
	display: flex;
	align-items: center;
	flex-direction: column;
	.head-Nav-Right-VIP-shop-title {
		width: 100%;
		box-sizing: border-box;
		padding-left: 25rem;
		text-align: left;
		margin-top: 35rem;
		margin-bottom: 16rem;
		font-size: 14rem;
		font-family: Microsoft YaHei UI;
		font-weight: 400;
		color: #364159;
	}
	.head-Nav-Right-VIP-shop-body {
		margin-bottom: 16rem;
		div {
			display: inline-block;
			&:nth-of-type(1) {
				margin-right: 14rem;
			}
			&:nth-of-type(2) {
				margin-right: 17rem;
			}
			p {
				font-size: 12rem;
				font-family: Microsoft YaHei UI;
				font-weight: 400;
				color: #64360d;
			}
			img {
				display: block;
				width: 52rem;
				height: 52rem;
				margin-bottom: 8rem;
				margin-left: auto;
				margin-right: auto;
			}
		}
	}
}
.head-Nav-Right-VIP-shop:hover {
	cursor: pointer;
}
.head-Nav-Right-VIP-shop button {
	display: block;
	width: 260rem;
	height: 36rem;
	background: linear-gradient(44deg, #f6da65 0%, #ffc43e 100%);
	border: none;
	border-radius: 15rem;
	opacity: 1;
	font-size: 16rem;
	font-family: Microsoft YaHei;
	font-weight: 400;
	line-height: 19rem;
	color: #3e2e09;
	opacity: 1;
	/* margin: 6rem auto 0rem; */
	cursor: pointer;
}
.head-Nav-Right-VIP-shop button:hover {
	background: #f7d688d7;
}
.head-Nav-Right-VIP:hover {
	background: linear-gradient(44deg, #fde354 0%, #ffda3e 100%);
}
/* #head-Nav-Right-VIP:hover #head-Nav-Right-VIP-shop{
	display: block;
} */
.head-Nav-Right-VIP:active {
	/* background: linear-gradient(44deg, #f6cf65 0%, #ffbc3e 100%); */
}
/* VIP动画效果  (暂时不需要)*/
/* #head-Nav-Right-VIP-Light {
	position: absolute;
	top: 0;
	width: 20rem;
	height: 28rem; */
/* background-image: linear-gradient(to right, #ebe5e53d, #f7f0f0af, #f7f0f077);
	transform: translateX(-10) skewX(-30deg);
} */

/* 控制栏 */
.head-Nav-Contral-btn {
	width: 24rem;
	height: 24rem;
	margin-left: 10rem;
	background-size: cover;
	display: inline-block;
	vertical-align: middle;
	-webkit-app-region: no-drag;
	/* cursor: pointer; */
	/* overflow: hidden; */
}
.contral-caidan {
	position: relative;
	/* background-image: url("./img/head-Nav-Contral/btn_set_24＊24@2x.png"); */
}
.contral-caidan-box {
	cursor: pointer;
	margin: 0;
	padding: 0;
	background-size: 100% 100%;
	width: 100%;
	height: 100%;
	background-image: url("./img/head-Nav-Contral/btn_set_24＊24@2x.png");
}
.up-contral-caidan-menu {
	/* 外层 */
}
.contral-caidan-menu {
	position: absolute;
	display: none;
	z-index: 99;
	background-image: url("./img/head-Nav-other/bg_set@2x.png");
	background-size: cover;
	height: 171.17rem;
	width: 150rem;
	left: 50%;
	top: 23rem;
	/* margin: 26rem 0 0 25rem; */
	padding: 0 9rem;
	padding-top: 12rem;
	transform: translateX(-50%);
	box-sizing: border-box;
	cursor: pointer;
}
.contral-caidan-menu div {
	z-index: 99;
	/* margin: 26rem 0 0 25rem; */
	height: 49rem;
	box-sizing: border-box;
	padding-left: 25rem;
}
/* 修复 */
.contral-caidan-menu div:hover {
	cursor: pointer;
	background-color: #eff7fc;
}
.contral-caidan-menu div::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}
.contral-caidan-menu a:nth-of-type(1) div {
	/* padding: 26rem 0 14rem 30rem; */
	border-radius: 7rem 7rem 0 0;
}
.contral-caidan-menu a:nth-of-type(2) div {
	border-top: 1rem solid #f4f4f4;
}
.contral-caidan-menu a:nth-of-type(3) div {
	border-top: 1rem solid #f4f4f4;
	border-radius: 0 0 7rem 7rem;
}

.contral-caidan-menu div img {
	display: inline-block;
	vertical-align: middle;
	width: 20rem;
	height: 20rem;
	margin-right: 9rem;
}
.contral-caidan-menu div span {
	vertical-align: middle;
	display: inline-block;
	/* height: 17rem; */
	font-size: 12rem;
	font-family: Microsoft YaHei;
	font-weight: 400;
	/* line-height: 14rem; */
	color: #5c7099;
	opacity: 1;
}
.contral-caidan-box:hover {
	background-image: url("./img/head-Nav-Contral-Hover/btn set 24 24-3.svg");
}
.contral-caidan-box:active {
	background-image: url("./img/head-Nav-Contral-Active/btn set 24 24-5.svg");
}
.contral-caidan-menu_en {
	background-image: url("./img/head-Nav-other/bg_set@2x_en.png");
	height: 172rem;
	width: 170rem;
	a {
		div {
			padding-left: 15rem;
			span {
				font-family: Arial;
			}
		}
	}
}
.contral-suoxiao {
	cursor: pointer;
	background-image: url("./img/head-Nav-Contral/btn suoxiao24 24.svg");
}
.contral-suoxiao:hover {
	background-image: url("./img/head-Nav-Contral-Hover/btn suoxiao24 24-2.svg");
}
.contral-suoxiao:active {
	background-image: url("./img/head-Nav-Contral-Active/btn suoxiao24 24-3.svg");
}
.contral-zuidahua {
	cursor: pointer;
	background-image: url("./img/head-Nav-Contral/btn qp 24 24.svg");
}
.contral-zuidahua:hover {
	background-image: url("./img/head-Nav-Contral-Hover/btn qp 24 24-2.svg");
}
.contral-zuidahua:active {
	background-image: url("./img/head-Nav-Contral-Active/btn qp 24 24-3.svg");
}
.contral-zuidahua_return {
	cursor: pointer;
	background-image: url("./img/head-Nav-Contral/btn_return@2x.png");
}
.contral-zuidahua_return:hover {
	background-image: url("./img/head-Nav-Contral-Hover/btn_btn_return_hover@2x.png");
}
.contral-zuidahua_return:active {
	background-image: url("./img/head-Nav-Contral-Active/btn_return_press@2x.png");
}

.contral-guanbi {
	cursor: pointer;
	background-image: url("./img/head-Nav-Contral/btn24 24.svg");
}
.contral-guanbi:hover {
	background-image: url("./img/head-Nav-Contral-Hover/btn24 24-2.svg");
}
.contral-guanbi:active {
	background-image: url("./img/head-Nav-Contral-Active/btn24 24-3.svg");
}
/* 用于js控制改变样式的class */
.head-nav-none {
	display: none !important;
}
.headNavIsLogin {
	display: none !important;
}
.headNavMenu {
	display: block !important;
}
</style>
